<template>
    <SecureHtmlElement
        v-for="node in nodes"
        :key="node.uid"
        :node="node"
        :show-external-content="showExternalContent"
        @activate-external-content="showExternalContent = true" />
</template>

<script>

export default {
    name: "SecureHtml",
    props: {
        html: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            showExternalContent: false,
        }
    },
    computed: {
        nodes() {
            const parser = new DOMParser();
            const htmlDoc = parser.parseFromString(this.html, 'text/html');
            const childNodeArray = [...htmlDoc.body.childNodes]
            return childNodeArray.filter(node => node.nodeType === 1 || (node.nodeType === 3 && node.textContent !== '\n'))
        },
    },
}
</script>

<style scoped>

</style>
